import { jsx as _jsx } from "react/jsx-runtime";
import "./separator.scss";
/*
 * Simple Separator Component
 */
const Separator = () => _jsx("div", { className: "separator" });
export default Separator;
